/**
 * The block size of the mobile navigation header — the bar with the menu button, the logo and the user
 * dropdown that `MobileNav` stacks ABOVE `main` below the `lg` breakpoint.
 *
 * SHARED, and that is the whole point of it existing. `MobileNav` pins its own height with this value as
 * both `minHeight` and `maxHeight`, so the header is exactly this tall; a page that bounds itself to the
 * viewport has to subtract the same amount, because its box starts where this header ends rather than at
 * the top of the screen. Two places, one value: change it here and the bound follows, instead of a page
 * silently mis-sizing itself by however much the header moved.
 *
 * A rem rather than a pixel count so it tracks the member's root font size, like the rest of the header's
 * own metrics.
 */
export const MOBILE_NAV_BLOCK_SIZE = "6rem"
